<template>
    <div>
        <h2 class="clickable" :class="{'collapsed-heading': !expanded}" @click="expanded=!expanded">
            Meter Resets
            <v-icon v-if="expanded">arrow_drop_up</v-icon>
            <v-icon v-else>arrow_drop_down</v-icon>
        </h2>
        <v-expand-transition>
            <meter-resets-list v-show="expanded" :unit="unit"></meter-resets-list>
        </v-expand-transition>
    </div>
</template>
<script>
import MeterResetsList from './MeterResets/MeterResetsList.vue';

export default {
    props: {
        unit: { required: true }
    },
    components: {
        MeterResetsList
    },
    data: () => {
        return {
            expanded: false
        };
    }
};
</script>
